import { useFormContext } from "react-hook-form";
import { cva } from "class-variance-authority";

import { FieldType } from "../../types";
import { FieldsProps } from "../types";

import { SelectField } from "./SelectField";
import { TextInputField } from "./TextInputField";
import { TextareaField } from "./TextareaField";
import { RadioGroupField } from "./RadioGroupField";
import { AutoComplete } from "./AutoComplete";
import { URLInputField } from "./URLInputField";
import { ContentAreaField } from "./ContentAreaField";

const fieldsStyles = {
  container: cva("flex flex-col", {
    variants: {
      size: {
        desktop: "gap-6",
        dialog: "gap-4",
      },
    },
    defaultVariants: {
      size: "desktop",
    },
  }),
};

export const Fields = ({ fields, stepId, size = "desktop" }: FieldsProps) => {
  const form = useFormContext();

  return (
    <div className={fieldsStyles.container({ size })}>
      {fields.map(field => {
        switch (field.type) {
          case FieldType.SELECT:
            return (
              <SelectField key={field.id} field={field} form={form} stepId={stepId} size={size} />
            );

          case FieldType.TEXT:
            return (
              <TextInputField
                key={field.id}
                field={field}
                form={form}
                stepId={stepId}
                size={size}
              />
            );

          case FieldType.TEXTAREA:
            return (
              <TextareaField key={field.id} field={field} form={form} stepId={stepId} size={size} />
            );

          case FieldType.RADIO:
            return (
              <RadioGroupField
                key={field.id}
                field={field}
                form={form}
                stepId={stepId}
                size={size}
              />
            );

          case FieldType.AUTOCOMPLETE:
            return (
              <AutoComplete key={field.id} field={field} form={form} stepId={stepId} size={size} />
            );

          case FieldType.URL:
            return (
              <URLInputField key={field.id} field={field} form={form} stepId={stepId} size={size} />
            );

          case FieldType.CONTENT_AREA:
            return (
              <ContentAreaField
                key={field.id}
                field={field}
                form={form}
                stepId={stepId}
                size={size}
              />
            );
          default:
            return null;
        }
      })}
    </div>
  );
};
